var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.667 22.667",
    id: "print",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.334 15.167c0 .367-.3.666-.667.666h-2.666v-3.166c0-1.103-.897-2-2-2H6.667c-1.103 0-2 .897-2 2v3.166H2a.668.668 0 0 1-.667-.666V5.833c0-.367.3-.666.667-.666h18.667c.367 0 .667.299.667.666zm-4.667 5.5c0 .367-.3.666-.666.666H6.667A.668.668 0 0 1 6 20.667v-8c0-.368.299-.667.667-.667H16c.367 0 .666.3.666.667V16.5zM4.667 2c0-.368.299-.667.666-.667h12c.368 0 .668.3.668.667v1.833H4.667zm16 1.833h-1.333V2c0-1.103-.897-2-2-2h-12c-1.104 0-2 .897-2 2v1.833H2c-1.103 0-2 .897-2 2v9.334c0 1.102.897 2 2 2h2.667v3.5c0 1.102.897 2 2 2H16c1.103 0 2-.898 2-2v-3.5h2.666c1.103 0 2-.898 2-2V5.833c0-1.103-.897-2-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.302 7.109a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.b9fcb8098f36060c68fd4cf8aadf640d.svg";
export { ForwardRef as ReactComponent };